import { render } from "./indexComponent.vue?vue&type=template&id=6aa4128c&scoped=true"
import script from "./indexComponent.vue?vue&type=script&lang=js"
export * from "./indexComponent.vue?vue&type=script&lang=js"

import "./indexComponent.vue?vue&type=style&index=0&id=6aa4128c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa4128c"]])

export default __exports__